import React from 'react';

import InstagramIcon from '../assets/instagram-icon';
import YoutubeIcon from '../assets/youtube-icon';
import TwitterIcon from '../assets/twitter-icon';

export const API = {
  banners: 'web/banner',
  transportBanners: 'web/bannerAngkutan',
  tours: 'web/wisata',
  tourDetails: 'web/wisataDetail',
  traffics: 'web/laluLintas',
  trafficDetails: 'web/laluLintasDetail',
  socMeds: 'web/socialMedia',
  events: 'web/event',
  eventDetails: 'web/detailEvent',
  transportServices: 'operational/service',
  transportSchedule: '/operational/angkutan',
  transportDetails: '/operational/detailAngkutan/id',
  destinationOptions: '/web/destination',
  overview: 'web/overview',
  popularCity: 'web/popularRute',
  popularDestination: '/web/rute/from',
  nearestTour: 'operational/wisata/id',
  licenses: 'web/perizinan',
  cities: 'web/city',
  submitComplaint: 'feedback/addFeedback',
  rate: 'operational/rate/id',
  submitRate: 'feedback/addRate',
  filter: {
    services: 'filter/services',
    classes: 'filter/class',
    operational: 'filter/operational',
    company: 'filter/company',
    price: 'filter/price'
  }
};

export const ROUTES = {
  home: '/',
  event: '/acara',
  trans_node: '/simpul-transportasi',
  cctv_online: 'https://cctv.jabarprov.go.id/',
  traffic: '/lalu-lintas',
  complaint: '/pengaduan',
  trans_schedule: '/jadwal-angkutan',
  search_schedule: '/jadwal-angkutan/cari',
  tour: '/wisata',
  licensing: '/perizinan'
};

export const COMPANY_ITEMS = {
  BUDIMAN: {
    name: 'BUDIMAN',
    logo: '/budiman-logo.png'
  }
};

export const SOCIAL_MEDIA_ICONS = [
  { label: 'Instagram', icon: <InstagramIcon /> },
  { label: 'Youtube', icon: <YoutubeIcon /> },
  { label: 'Twitter', icon: <TwitterIcon /> }
];
